/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: actions.ts
 * Class: actions.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { ActionTree } from 'vuex';
import { TextItem, TextState } from './types';
import { RootState } from '../types';
import { ConfigurationAPI } from '../../plugins/configuration/types/configuration';

export const actions: ActionTree<TextState, RootState> = {

  getTextFromDOM({ commit }, dom: ConfigurationAPI): Promise<TextItem> {
    commit('textLoading');
    return new Promise((resolve, reject) => {
      // --- since we cannot rely on http response codes
      // --- we have to use custom type guards to check if the page data is correct
      if (dom.pageData !== undefined && (dom.pageData as TextItem).content !== undefined) {
        commit('textLoaded', (dom.pageData as TextItem));
        resolve((dom.pageData as TextItem));
      } else {
        // --- no page data, 404 error
        commit('textError', { code: 404, message: null, data: dom.pageData });
        reject();
      }
    });
  },
};
